var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5965 5.75057C19.1567 2.82953 16.5922 0.265044 13.6711 0.825254L5.2845 2.43368C3.4614 2.78332 2.0034 4.16331 1.54019 5.95647C0.615353 9.53659 3.93555 12.8086 7.50056 11.7602C7.599 11.7312 7.69047 11.8227 7.66152 11.9212C6.61315 15.4862 9.88512 18.8064 13.4653 17.8816C15.2584 17.4183 16.6384 15.9603 16.9881 14.1372L18.5965 5.75057ZM13.9301 2.17564C15.8967 1.79848 17.6232 3.52501 17.2461 5.49159L15.6377 13.8782C15.3889 15.1752 14.4042 16.2189 13.1214 16.5503C10.5573 17.2126 8.2387 14.8321 8.98067 12.3091C9.31665 11.1666 8.25515 10.1051 7.11263 10.441C4.58959 11.183 2.20913 8.8644 2.87148 6.30038C3.20287 5.01756 4.24651 4.03281 5.54349 3.78407L13.9301 2.17564Z",
    fill: "#CB90FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5325 13.9724C2.80098 13.7039 2.80098 13.2686 2.5325 13.0002C2.26401 12.7317 1.82871 12.7317 1.56023 13.0002L0.263864 14.2965C-0.00462134 14.565 -0.00462139 15.0003 0.263864 15.2688C0.532349 15.5373 0.96765 15.5373 1.23614 15.2688L2.5325 13.9724Z",
    fill: "#CB90FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7734 14.6206C6.04189 14.3521 6.04189 13.9168 5.7734 13.6483C5.50492 13.3799 5.06962 13.3799 4.80113 13.6483L3.50477 14.9447C3.23628 15.2132 3.23628 15.6485 3.50477 15.917C3.77326 16.1855 4.20856 16.1855 4.47704 15.917L5.7734 14.6206Z",
    fill: "#CB90FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42159 17.8615C6.69007 17.593 6.69007 17.1577 6.42159 16.8892C6.1531 16.6208 5.7178 16.6208 5.44931 16.8892L4.15295 18.1856C3.88447 18.4541 3.88447 18.8894 4.15295 19.1579C4.42144 19.4264 4.85674 19.4264 5.12522 19.1579L6.42159 17.8615Z",
    fill: "#CB90FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadsInactive);
export default __webpack_public_path__ + "static/media/LeadsInactive.9f15d562795d01f36f5aafb534d14884.svg";
export { ForwardRef as ReactComponent };